import { Column } from "devextreme-react/data-grid";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { hinhThucMienGiamApi } from "../../../api/hinhThucMienGiamApi";
import { Button } from "../../../components/buttons";
import { DefaultDataGrid } from "../../../components/data-grid-bk";
import { NamHocDropDownText } from "../../../components/dropdowntext-namhoc";
import { AnimationPopup } from "../../../components/modal";
import { showNotify } from "../../../helpers/toast";
import { RootState } from "../../../state/reducers";

type MienGiamCopyModalProps = {
    nam_hoc_to: string,
    animationOf: string,
    onClose: () => void,
    onSuccess: () => void
}
export const MienGiamCopyModal = (props: MienGiamCopyModalProps) => {
    const [nam_hoc_from, set_nam_hoc_from] = useState<string>("");
    const [sf_hinhthucmiengiams, set_sf_hinhthucmiengiams] = useState<any[]>([])
    const [isLoading, SetIsLoading] = useState<boolean>(false)
    const [sf_hinhthucmiengiam_selected_ids, set_sf_hinhthucmiengiam_selected_ids] = useState<number[]>([])
    const [isSaving, SetIsSaving] = useState<boolean>(false)
    const { dm_coso_id } = useSelector((state: RootState) => state.common);

    const grid = useRef<any>()
    const onClose = useCallback(() => {
        window.animationHidePopup(props.animationOf || "")
        setTimeout(() => {
            props.onClose();
        }, 500);
    }, [props.animationOf])
    const onSelectionChanged = (ids: number[]) => {
        set_sf_hinhthucmiengiam_selected_ids(ids);
    }
    useEffect(() => {
        if (nam_hoc_from) {
            handleReload(nam_hoc_from);
        }
    }, [nam_hoc_from])
    const handleReload = async (nam_hoc_from: string) => {

        const res = await hinhThucMienGiamApi.select(nam_hoc_from);
        set_sf_hinhthucmiengiam_selected_ids([])
        if (res.is_success) {
            set_sf_hinhthucmiengiams(res.data.filter((x: any) => x.dm_coso_id === dm_coso_id))
        }
    }
    const columns = useMemo((): any => {
        let result: any = [
            <Column key={1} dataField="nam_hoc" caption="Năm học"></Column>,
            <Column key={2} dataField="ma_hinh_thuc" caption="Mã hình thức"></Column>,
            <Column key={3} dataField="hinh_thuc_mien_giam" caption="Hình thức miễn giảm"></Column>,
            <Column key={4} dataField="nhom_mien_giam" caption="Nhóm miễn giảm"></Column>
        ]

        return result;
    }, [])
    const isValidCopy = useMemo(() => {
        if (nam_hoc_from && nam_hoc_from < props.nam_hoc_to && sf_hinhthucmiengiam_selected_ids.length > 0) return true;
        return false;
    }, [props.nam_hoc_to, nam_hoc_from, sf_hinhthucmiengiam_selected_ids])
    const handleSubmit = async () => {
        SetIsSaving(true);
        const res = await hinhThucMienGiamApi.copy({
            nam_hoc_from: nam_hoc_from,
            nam_hoc_to: props.nam_hoc_to,
            sf_hinhthucmiengiam_ids: sf_hinhthucmiengiam_selected_ids,
            dm_coso_id: dm_coso_id
        })
        SetIsSaving(false)
        if (res.is_success) {
            showNotify({ message: "Sao chép thành công", type: "success" })
            props.onSuccess();
        } else {
            showNotify({ message: "Có lỗi " + (res.message || ""), type: "error" });
        }
    }

    return (
        <AnimationPopup
            animationOf={props.animationOf}
            title={`Sao chép miễn giảm sang năm học ${props.nam_hoc_to}`}
            maxWidth={1000}
            onClose={onClose}
        >
            <div>
                <div className="pop-up-form">
                    <div className="form-inline page-toolbar-filter" style={{ minHeight: 40 }}>
                        <span>Sao chép từ năm: </span>
                        <NamHocDropDownText
                            value={nam_hoc_from}
                            placeHolder="Chọn năm" preText=""
                            onSelectionChanged={(value) => { set_nam_hoc_from(value) }} />
                    </div>
                </div>
                <DefaultDataGrid
                    columns={columns}
                    gridRef={grid}
                    dataSource={sf_hinhthucmiengiams}
                    keyExpr="id"
                    defaultPageSize={50}
                    height={window.innerHeight - 300}
                    isLoading={isLoading}
                    wordWrapEnabled={true}
                    selection={{
                        mode: "multiple",
                        onSelectionChanged: (e: any) => {
                            onSelectionChanged(e.selectedRowKeys)
                        },
                        selectedRowKeys: sf_hinhthucmiengiam_selected_ids
                    }}
                />
                <div className="pop-up-actions">
                    <Button type="normal" icon="fa fa-times" text="Đóng" onClick={onClose}></Button>{' '}
                    <Button type="normal" icon="fas fa-check-square" text="Cập nhật"
                        isLoading={isSaving}
                        isDisabled={!isValidCopy} onClick={handleSubmit}></Button>
                </div>
            </div>
        </AnimationPopup>
    );
}